
<template>
  <div class="date-picker-box elevation-2 mb-2 pb-2">
    <h4 v-if="showMode == 1" class="text-xs-center pt-1" @click="unreservateConfirm = true">MODULO {{ modulePosition+1 }} - {{ currentModule.days[0].day | convertDate }}</h4>
    <v-date-picker width="" v-model="datePicked" :first-day-of-week="1" :full-width="true" :no-title="true" :picker-date.sync="newDateRef" :allowed-dates="compAllow" locale="pt-BR"/>
    <!-- <h4 v-if="showMode == 1" class="text-xs-center py-1">MODULO {{ modulePosition+1 }} - {{ currentModule.days[0].day | convertDate }}</h4> -->

    <v-dialog v-model="unreservateConfirm" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>LIMPAR DATA E/OU SALA</v-card-title>
        <v-card-text>
          <p class="ma-0"><strong>MODULO: </strong>{{ modulePosition+1 }}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="unreservateConfirm = false">CANCELAR</v-btn>
          <v-btn color="error" text @click="unreservate(currentModule)">CONFIRMAR E LIMPAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['currentModule', 'module-position', 'class-data', 'date-ref', 'comp-allow', 'show-mode'],
  data() {
    return {
      datePicked: '',
      // dateRef: '',
      firstIterate: true,
      deleteConfirm: false,
      unreservateConfirm: false,
      unreservateModule: undefined
    }
  },
  created() {
    setTimeout(() => {
      // EVITA CHAMADAS DE SALVAMENTO NO CARREGAMENTO DA PAGINA! //
      this.firstIterate = false
    }, 1000)
    // CARREGA DATAS EM MODULOS, HAVENDO REGISTROS NO BANCO! //
    if (this.currentModule.days[0].day != null) {
      this.datePicked = moment.utc(this.currentModule.days[0].day).format('YYYY-MM-DD')
      this.$emit('dateRefChanged', { date: moment(this.datePicked).format(`YYYY-MM`) })
      this.classData.modules[this.modulePosition].dateRef = moment(this.datePicked).format(`YYYY-MM`)
    } else {
      if (this.modulePosition == 0) {
        this.$emit('dateRefChanged', { date: moment().add(1, `month`).format(`YYYY-MM`) })
        this.currentModule.dateRef = moment().add(1, `month`).format(`YYYY-MM`)
      } else {
        this.$emit('dateRefChanged', { date: moment(this.classData.modules[this.modulePosition-1].dateRef).add(1, `month`).format(`YYYY-MM`) })
        this.classData.modules[this.modulePosition].dateRef = moment(this.classData.modules[this.modulePosition-1].dateRef).add(1, `month`).format(`YYYY-MM`)
      }
    }
  },
  methods: {
    unreservate(module) {
      this.$http.put(`/days/unreservate/${module.id}`).then(success => {
        this.unreservateConfirm = false
        window.location.reload()
      }).catch(err => {

      })
    }
  },
  computed: {
    // MONITORA ALTERAÇÕES DE DATA PARA TRATAMENTO! //
    newDateRef: {
      set: function (value) {
        this.dateRef = value
        this.$emit('newDateChanged', { date: value, position: this.modulePosition })
      },
      get: function () {
        return this.dateRef
      }
    }
  },
  watch: {
    // MONITORA ALTERAÇÕES DE DATA PARA AÇÕES! //
    datePicked(current, old) {
      if (this.firstIterate) {}
      else if (this.modulePosition == 0) {
        this.currentModule.days[0].day = current
        this.$emit('dayChanged', {currentDay: current, oldDay: old, modulePosition: this.modulePosition})
        // AVISA PARA O MONITORADOR QUE A SALA FOI CANCELADA!
        this.currentModule.days[0].room_id = null
        this.currentModule.days[0].room_name = null
      } else if (this.modulePosition > 0 && this.classData.modules[this.modulePosition-1].days[0].day != null) {
        this.currentModule.days[0].day = current
        this.$emit('dayChanged', {currentDay: current, oldDay: old, modulePosition: this.modulePosition})
        // AVISA PARA O MONITORADOR QUE A SALA FOI CANCELADA!
        this.currentModule.days[0].room_id = null
        this.currentModule.days[0].room_name = null
      } else {
        this.datePicked = ''
      }
      this.firstIterate = false
    }
  }
}
</script>

<style scoped>
  .date-picker-box {
    background-color: #fff;
  }
  .date-picker-box .v-card {
    box-shadow: none;
  }
</style>
